import {LOAD_DIETARY} from '../actions/types';

const initialState = {
    list: [],
    loaded: false
};

export default function (state = initialState, action) {

    const {payload, type} = action

    switch (type) {

        case LOAD_DIETARY:

            return {
                ...state,
                list: payload,
                loaded: true
            };

        default:
            return state;
    }
}
